<div class="bc-workitem-simple-timer">
  <div class="counter">
    <div class="timer" *ngIf="showTimer && !showRemainingSeconds">
      {{ timerText }}
    </div>
  </div>
  <div class="counter">
    <div class="timer remaining-color" *ngIf="showRemainingSeconds">
      {{ remainingSeconds }}
    </div>
  </div>
</div>
